<template>
    <div>
        <div class="simple__block">

            <div class="order__block_info">
                <template>
                    <div class="row">
                        <div class="col-12 col-md-auto">
                            <p>
                                <label>{{ get_translation_constant('text_tracking_number_full') }}:</label>
                                <a href="#" class="order__traking_number">{{ parcel.track_code }}</a>
                                <span class="copy__traking_number">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z"
                                        fill="#06C"></path></svg>
                                        <span class="copy__traking_alert">{{
                                                get_translation_constant('text_copied_to_clipboard')
                                            }}</span>
                            </span>
                            </p>
                            <p><label>{{ get_translation_constant('text_flight') }}:</label> {{
                                    getOrderFlight(parcel)
                                }}
                            </p>
                        </div>
                        <div class="col-12 col-md-auto pl-md-5">
                            <p><label>{{ get_translation_constant('text_arrival_date') }}:</label> <span>{{
                                    parcel.date
                                }}</span></p>
                            <p><label>{{ get_translation_constant('text_bar_code') }}:</label>
                                <a href="javascript:void(0)">{{
                                        (typeof parcel.bar_code !== 'undefined') && (typeof parcel.bar_code !== null) ? parcel.bar_code : '-'
                                    }}</a>
                            </p>
                        </div>
                    </div>
                </template>
                <div class="order__print">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z"
                            fill="#515154"/>
                    </svg>
                </div>
            </div>
            <!--            <h4 class="h_text" v-if="['sent'].includes(ordertype)">{{ get_translation_constant('text_bill') }}</h4>-->
            <!-- if ukraine and not delivered-->
            <table class="table table__arrived__item__orders">
                <thead>
                <tr>
                    <th>{{ get_translation_constant('text_weight') }}</th>
                    <th>{{ get_translation_constant('text_rate') }}</th>
                    <th>{{ get_translation_constant('text_additional_services') }}</th>
                    <th v-if="parcelNotPaidBill ">
                        {{ get_translation_constant('text_customs_tax') }}
                    </th>
                    <th>{{ get_translation_constant('text_total') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td :data-label="get_translation_constant('text_weight')">{{
                            parcel.weight
                        }}{{ get_translation_constant('text_kg') }}
                    </td>
                    <!-- if ukraine and arrived-->
                    <template>
                        <td :data-label="get_translation_constant('text_rate')">
                            <strong>{{ parcel.tariff_to_kg }}</strong></td>
                    </template>
                    <td :data-label="get_translation_constant('text_additional_services')"
                        v-if="((parcel.services !==null) && (parcel.services.length >0)) || ((parcel.solutions !==null) && parcel.solutions.length >0) ">
                        <strong>{{ totalServicesSum }}</strong>
                        <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                        fill="#515154"/>
                                </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner tooltip__small" v-html="getServicesPrices"></span>
                            </span>
                        </span>
                    </td>
                    <td :data-label="get_translation_constant('text_additional_services')" v-else>-</td>
                    <td v-if="parcelNotPaidBill "><strong
                        :class="[billStatusClass,'customs-error']">{{ parcel.bill.amount }}$</strong>
                        <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                        fill="#515154"/>
                                </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner tooltip__small"
                                      v-html="billInfo.title"></span>
                            </span>
                        </span>
                    </td>
                    <td :data-label="get_translation_constant('text_total')" v-if="parcel.total_price !==null">
                        <strong>{{ parcel.total_price }}$</strong>
                    </td>
                    <td :data-label="get_translation_constant('text_total')" v-else>-</td>
                </tr>
                </tbody>
            </table>
            <div v-if="parcelHasWaitingDocumentRequest" class="d-md-flex" :class="parcelDocumentRequestData.class">
                {{ parcelDocumentRequestData.content }}
            </div>
        </div>
        <div class="simple__block" v-if="parcelHasDocumentRequest ||parcelHasBill">
            <h3>{{ get_translation_constant('text_customs_payment_confirmation') }}</h3>
            <div class="form-check form-switch" v-if="parcelHasBill">
                <input checked class="form-check-input" id="acceptBill"
                       name="notification" type="checkbox" v-model="not_accept_bill">
                <label class="form-check-label"
                       for="acceptBill">{{
                        get_translation_constant('text_customs_tax_less')
                    }}</label>
            </div>
            <file-upload
                v-on:childToParent="setFiles($event, 'files')"
                :files_array="serverFiles"
                :multiple="true"
                :translations="translations"
                :ajax="false"
                :lng="lng"
                :upload_files_link="upload_files_link"
                :delete_files_link="delete_files_link"
                :additional_ajax_params="{ parcel_id: parcel.id }"
                :downloadlink="downloadlink"
                :template="'arrived'"
                ref="fileUpload"
            ></file-upload>
            <div class="form__col">
                <label for="comments">{{ get_translation_constant('text_comment') }}</label>
                <textarea
                    v-model="comment"
                    class="form__control"
                    name="comments"
                    id="comments"
                    :placeholder="get_translation_constant('text_comment')">
                </textarea>
            </div>
            <div class="d-flex justify-content-end">
                <a href="javascript:void(0)" class="btn btn__large btn__blue"
                   @click.prevent="sendConfirmation()">{{ get_translation_constant('text_send_confirmation') }}</a>
            </div>

            <div class="block-message-history">
                <div class="block-content">
                    <h4 class="h_text">{{ get_translation_constant('text_message_history') }}</h4>
                    <customs-comment v-for="(comment, key) in comments" :comment="comment" :key="key"
                                     :account="account"></customs-comment>
                </div>
            </div>
        </div>
        <div class="simple__block  mt-4" v-if="parcel.pictures.length">
            <file-upload
                :files_array="serverPictures"
                :multiple="true"
                :translations="translations"
                :ajax="false"
                :lng="lng"
                :upload_files_link="upload_files_link"
                :delete_files_link="delete_files_link"
                :additional_ajax_params="{ parcel_id: parcel.id }"
                :downloadlink="downloadlink"
                :template="'preview-photo'"
                ref="fileUpload"
            ></file-upload>
        </div>
        <!-- Modal order Payment Success -->
        <alert-modal :title="modalTitle" :type="modalType" :message="modalMessage"
                     :modalId="modalId"></alert-modal>
    </div>
</template>
<script>
export default {
    name: "StoppedOrder",
    props: {
        translations: {
            type: [Object, Array]
        },
        orders: {
            type: [Object, Array]
        },
        paymentmethods: {
            type: [Object, Array],
            default: () => []
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        parcel: {
            type: [Object],
            default: null
        },
        deliverymethods: {
            type: [Object, Array],
            default: () => []
        },
        ordertype: {
            required: true,
            type: [String]
        },
        account: {
            type: [Object, Array],
            default: () => []
        },
        locations: {
            type: [Object, Array]
        },
        savedeliverylink: {
            type: [String]
        },
        dopaymentlink: {
            type: [String]
        },
        neworderslink: {
            type: [String]
        },
        ordersonwarehoselink: {
            type: [String]
        },
        sentorderslink: {
            type: [String]
        },
        arrivedorderslink: {
            type: [String]
        },
        deliveredorderslink: {
            type: [String]
        },
        upload_files_link: {
            type: [String]
        },
        delete_files_link: {
            type: [String],
            default: null
        },
        downloadlink: {
            type: [String],
            default: null
        },
        refusebilllink: {
            type: [Array],
            default: null
        },
        confirmorderlink: {
            type: [String],
            default: null
        }
    },
    data() {
        return {
            errors: [],
            order: {},
            trigger: {
                successPayment: false,
                successDelivery: false
            },
            modal: {
                type: 'success',
                title: '',
                message: '',
                id: 'SendToDelivered'
            },
            agents: [],
            locationPrefixes: [],
            not_accept_bill: null,
            files: [],
            serverFiles: [],
            serverPictures: [],
            comment: '',
            comments: []
        }
    },
    methods: {
        hasError(error, deep = false, level = 1) {
            if (deep) {
                if (level === 1) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined')
                        return 'has__error';
                }
                if (level === 2) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined' && typeof this.errors[split[0]][split[1]][split[2]] !== 'undefined')
                        return 'has__error';
                }
            }
            if (this.errors[error])
                return 'has__error';
        },
        hasErrorMessage(error, deep = false, level = 1) {

            if (deep) {
                if (level === 1) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined')
                        return this.errors[error][0];
                }
                if (level === 2) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined' && typeof this.errors[split[0]][split[1]][split[2]] !== 'undefined')
                        return this.errors[error][0];
                }
            }

            if (this.errors[error])
                return this.errors[error][0];
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        getOrderFlight(order) {
            return order?.flight?.title;
        },
        formatText(text) {

            if (typeof (text === 'undefined') || (text === '') || (text == null)) {
                return ''
            }
            let tmp = text.toLowerCase();
            return tmp.charAt(0).toUpperCase() + tmp.slice(1);
        },

        sendConfirmation() {
            let formData = new FormData();
            for (let key = 0; key < this.files.length; key++) {
                formData.append('files[' + key + ']', this.files[key]);
            }
            if (this.comment !== '') {
                formData.append('comment', this.comment)
            }
            if (this.not_accept_bill !== null) {
                formData.append('not_accept_bill', this.not_accept_bill ? 1 : 0)
            }
            formData.append('parcel_id', this.parcel.id)

            axios.post(this.confirmorderlink,
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                if (response.status === 200) {
                    this.serverFiles = response.data.customsFiles;
                    this.comments = [...response.data.customsComments];


                    this.files = [];
                    this.$refs.fileUpload.clearFiles();
                    this.$refs.fileUpload.setServerFiles(this.serverFiles);

                    this.modal.title = this.get_translation_constant('text_success_confirmation_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_confirmation_message');
                    this.trigger.successDelivery = true;
                    setTimeout(() => {
                        document.getElementById('AlertModalBtn' + this.modal.id).click();
                    }, 200)
                }

            }).catch(error => {
                console.log(error)
                //  console.log(error)
                /*
                if (error.response.status === 400) {
                    console.log(response.data)
                }
                if (error.response.status === 422) {
                    console.log(response.data)
                }
                if (error.response.status === 500) {
                    console.log(response.data)
                }

                 */
            });

        },
        setFiles(e) {
            this.files = e;
        }
    },
    computed: {
        totalProductPrice() {
            let price = 0;
            if (typeof this.parcel.products !== 'undefined') {
                this.parcel.products.map((product) => {
                    price += product.qty * product.price;
                });
            }
            return price.toFixed(2);
        },
        getDateText() {
            if (this.ordertype === 'on-warehouse') {
                return this.get_translation_constant('text_sent_date');
            }
            return this.get_translation_constant('text_date');
        },
        getClassDeliveryUkraine() {
            //check if Ukraine
            if (this.account.location_id === 1) {
                return 'delivery-ukraine'
            }
            return ''
        },
        totalServicesSum() {
            let price = 0;
            let percentCoefficient = 0;
            let extraServiceSum = 0;
            this.parcel.services.map((item) => {
                if (!!item.as_a_percentage) {
                    percentCoefficient += parseFloat(item.value);
                } else {
                    extraServiceSum += parseFloat(item.value);
                }
            })

            this.parcel.solutions.map((item) => {
                if (!!item.as_a_percentage) {
                    percentCoefficient += parseFloat(item.value);
                } else {
                    extraServiceSum += parseFloat(item.tariff);
                }
            })
            price = percentCoefficient * this.parcel.weight_price / 100 + extraServiceSum;
            return price.toFixed(2) + '$';
        },
        getServicesPrices() {
            let html = '';
            this.parcel.services.map((service) => {
                html += '<span class="line d-flex justify-content-between">';
                html += '<span class="text">' + service.title + '</span>';
                if (!!service.as_a_percentage) {
                    html += '<span class="val">' + (this.parcel.weight_price * service.value / 100).toFixed(2);
                } else {
                    html += '<span class="val">' + service.value.toFixed(2);
                }
                html += '$' + '</span>';
                html += '</span>';
            });
            this.parcel.solutions.map((solution) => {
                html += '<span class="line d-flex justify-content-between">';
                html += '<span class="text">' + solution.title + '</span>';
                if (!!solution.as_a_percentage) {
                    html += '<span class="val">' + (this.parcel.weight_price * solution.value / 100).toFixed(2);
                } else {
                    html += '<span class="val">' + parseFloat(solution.tariff).toFixed(2);
                }
                html += '$' + '</span>';
                html += '</span>';
            });
            return html;
        },
        modalTitle() {
            return this.modal.title
        },
        modalMessage() {
            return this.modal.message
        },
        modalType() {
            return this.modal.type
        },
        modalId() {
            return this.modal.id
        },
        filteredPaymentMethods() {
            return this.paymentmethods;
            /*
            return this.paymentmethods.filter((payment) => {
                //balance
                //TODO check if NaN, etc
                if (payment.payment_type.id === 1) {
                    return parseFloat(this.order.total_price) <= parseFloat(this.account.balance);
                    //bonus
                } else if (payment.payment_type.id === 2) {
                    return parseFloat(this.order.total_price) <= parseFloat(this.account.bonus);
                } else return true;
            }) */
        },
        parcelHasDocumentRequest() {
            return this.parcel.customs_document_request !== null;
        },
        parcelHasWaitingDocumentRequest() {
            return (this.parcel.customs_document_request !== null) && (this.parcel.customs_document_request?.status === 1);
        },
        parcelHasBill() {
            return this.parcel.bill !== null;
        },
        parcelNotPaidBill() {
            return (this.parcel.bill !== null) && (parseInt(this.parcel.bill?.status) === 1);
        },
        billStatusClass() {
            switch (this.parcel?.bill?.status) {
                //not paid
                case 1:
                    return 'red';
                //paid
                case 2:
                    return 'green';
                //rest
                default :
                    return ''
            }
        },
        parcelDocumentRequestData() {
            let className = '';
            let contentData = '';

            if ((typeof this.parcel.customs_document_request !== 'undefined') && (this.parcel.customs_document_request !== null)) {

                contentData = this.parcel.customs_document_request.template.content;

                switch (this.parcel.customs_document_request?.status) {
                    //waiting
                    case 1 :
                        className = 'verification-customs customs-error'
                        break;
                    //received
                    case 2 :
                        className = 'verification-customs customs-review'
                        break;
                    //closed
                    case 3 :
                        className = 'verification-customs customs-success'
                        break;
                }
            }
            return {
                class: className,
                content: contentData,
            }
        },
        billInfo() {
            return {
                id: this.parcel.bill.id,
                title: this.parcel.bill.title
            }
        }

    },
    created() {
        this.order = this.parcel;
        this.locationPrefixes = Object.values(this.locations.filter((location) => {
            return location.id === this.account.location_id
        })).map((location) => {
            return {
                image: location.image,
                title: location.phone_prefix
            };
        })
        //
        this.serverFiles = this.parcel.customs_files;
        this.serverPictures = this.parcel.pictures;
        this.comments = [...this.parcel.customs_comments ?? []];

    },
    mounted() {
    }
}
</script>

<style scoped>
.delivery-ukraine {
    width: 25%;
}
</style>
